import React from 'react'
import { QuotationForm } from './QuotationForm'

export const QuotationCreateView = ({ onSubmit, initialData }) => {
  return (
    <div className="min-h-screen bg-brand-contentBg p-4 sm:p-6">
      <QuotationForm
        onSubmit={onSubmit}
        initialData={initialData}
      />
    </div>
  )
}
